import Swiper from 'swiper/bundle';

function initSliderMagazines() {
	document.querySelectorAll(".slide-magazines-container").forEach(slide => {
		const nextButton = slide.querySelector(".swiper-button-next");
		const prevButton = slide.querySelector(".swiper-button-prev");

		const swiper = new Swiper(slide, {
			slidesPerView: "auto",
			spaceBetween: 32,
			centeredSlides: true,
			grabCursor: 'true',

			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
		});
	});
}

if (document.querySelector(".slide-magazines-container")) {
	initSliderMagazines();
}
